import React from "react";

import { useTranslations } from "next-intl";

// Icons
import IconArea from "@/icons/content/property/area.svg";
import IconLandArea from "@/icons/content/property/landArea.svg";
import IconBedroom from "@/icons/icon_bed.svg";
import IconRooms from "@/icons/icon_door.svg";
import IconFloor from "@/icons/stairs.svg";
import { cn } from "@/utils/cn";

interface PropertyMainInfoProps {
  className?: string;
  area?: number | string | null;
  bedrooms?: number | null;
  rooms?: number | null;
  floor?: number | null;
  floors?: number | string | null;
  landArea?: number | string | null;
}

interface MainInfoItem {
  icon: React.ComponentType<{
    width?: number;
    height?: number;
    className?: string;
  }>;
  value: string;
  key: string;
}

const MainInfoItem: React.FC<MainInfoItem> = ({ icon: Icon, value }) => (
  <div className="flex items-center gap-3">
    <Icon
      width={20}
      height={20}
      className={"text-gray-1000"}
    />
    <span className="text-sm text-gray-1200 font-medium">{value}</span>
  </div>
);

export const PropertyMainInfo: React.FC<PropertyMainInfoProps> = ({
  className,
  area,
  bedrooms,
  rooms,
  floor,
  floors,
  landArea,
}) => {
  const t = useTranslations();

  const allInfoItems: MainInfoItem[] = [
    (area ?? false) && {
      key: "area",
      icon: IconArea,
      value: `${area} ${t("m2")}`,
    },
    (landArea ?? false) && {
      key: "landArea",
      icon: IconLandArea,
      value: `${landArea} ${t("Ap")}`,
    },
    (rooms ?? false) && {
      key: "rooms",
      icon: IconRooms,
      value: `${rooms} ${t("rms")}.`,
    },
    (bedrooms ?? false) && {
      key: "bedrooms",
      icon: IconBedroom,
      value: `${bedrooms} ${t("br")}.`,
    },
    ((floor ?? false) || (floors ?? false)) && {
      key: "floor",
      icon: IconFloor,
      value: `${floor && floors ? `${floor} / ${floors}` : `${floor || floors}`} ${t("fl")}.`,
    },
  ].filter(Boolean) as MainInfoItem[];

  return (
    <div className={cn("flex items-center flex-wrap gap-6", className)}>
      {allInfoItems.map((item) => (
        <MainInfoItem
          key={item.key}
          icon={item.icon}
          value={item.value}
        />
      ))}
    </div>
  );
};
